export enum ListType {
    Template = "template",
    Target = "target"
}